import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function WhyItFailed() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const failedMethods = [{
    title: 'Dejarlo llorar (Cry It Out)',
    description: 'Solo eleva el estrés del bebé y rompe el vínculo de seguridad que necesita para soltarse al sueño.'
  }, {
    title: 'Mecerlo hasta el infinito',
    description: 'Crea una dependencia donde el bebé solo duerme si tú te mueves, atrapándote en un ciclo sin fin.'
  }, {
    title: 'Rutinas de manual',
    description: 'No consideran las "ventanas de sueño" reales ni la temperatura corporal, que es lo que realmente activa el cerebro para dormir.'
  }];
  return <section ref={ref} className="w-full bg-white py-16 md:py-24 px-6" data-id="element-202">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.7
    }} className="max-w-4xl mx-auto" data-id="element-203">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-warm-brown mb-12 text-center" data-id="element-204">
          Lo que ya intentaste (y por qué no funcionó)
        </h2>

        <div className="space-y-6" data-id="element-205">
          {failedMethods.map((method, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-cream rounded-xl p-6 md:p-8 border-l-4 border-terracotta/40" data-id="element-206">
              <div className="flex items-start gap-4" data-id="element-207">
                <XIcon className="w-6 h-6 text-terracotta flex-shrink-0 mt-1" data-id="element-208" />
                <div data-id="element-209">
                  <h3 className="font-serif text-xl md:text-2xl font-semibold text-warm-brown mb-3" data-id="element-210">
                    {method.title}
                  </h3>
                  <p className="text-lg text-warm-brown/90 leading-relaxed" data-id="element-211">
                    {method.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}